<script setup lang="ts">
import { useCookies } from '@vueuse/integrations/useCookies'
import { computed } from 'vue'
import { useQueryClient } from '@tanstack/vue-query'
import BIcon from '@/components/BIcon.vue'
import { COOKIE_OPTIONS } from '@/constants/cookies'

const cookies = useCookies()
const query = useQueryClient()

const uiCookie = computed(() => parseInt(cookies.get('ui_pr')) || false)
const apiCookie = computed(() => parseInt(cookies.get('api_pr')) || false)

const clearUICookie = () => {
    cookies.remove('ui_pr', COOKIE_OPTIONS)
    query.clear()
    location.reload()
}

const clearAPICookie = () => {
    cookies.remove('api_pr', COOKIE_OPTIONS)
    query.invalidateQueries()
}
</script>

<template>
    <div
        v-if="uiCookie || apiCookie"
        class="fixed left-0 top-0 z-50">
        <div
            class="flex items-center rounded-br-lg bg-gradient-to-br from-yellow-500 to-amber-600 px-3 py-1.5 text-xs font-semibold text-white shadow-md">
            <template v-if="uiCookie">
                <div class="flex items-center gap-2">
                    <span>UI PR-{{ uiCookie }}</span>
                    <button
                        class="flex h-5 w-5 items-center justify-center rounded-full border border-amber-400 bg-amber-700 shadow-sm transition-all duration-200 hover:scale-110 hover:bg-amber-800"
                        title="Exit UI pull request"
                        @click="clearUICookie">
                        <BIcon
                            class="h-3.5 w-3.5 text-amber-100"
                            icon="cancel" />
                    </button>
                </div>
            </template>
            <template v-if="uiCookie && apiCookie">
                <div class="mx-2 h-4 w-px bg-white bg-opacity-40"></div>
            </template>
            <template v-if="apiCookie">
                <div class="flex items-center gap-2">
                    <span>API PR-{{ apiCookie }}</span>
                    <button
                        class="flex h-5 w-5 items-center justify-center rounded-full border border-amber-400 bg-amber-700 shadow-sm transition-all duration-200 hover:scale-110 hover:bg-amber-800"
                        title="Exit API pull request"
                        @click="clearAPICookie">
                        <BIcon
                            class="h-3.5 w-3.5 text-amber-100"
                            icon="cancel" />
                    </button>
                </div>
            </template>
        </div>
    </div>
</template>
